import React from "react";

export const ReportChartPage = ({ pageRef, totalPages }) => {
  return (
    <div
      className="mx-auto my-5 flex h-[1150px] w-[800px] flex-col bg-white"
      ref={pageRef}
    >
      <img
        alt="chart"
        className="mt-[270px] -rotate-90"
        src="/images/pdf-report/swing-score-report-pdf-chart-1.png"
      />

      <div className="mt-[230px] flex justify-end">
        <div className="text-grayTrue500 mr-20 text-[10px]">
          Page {2} of {totalPages}
        </div>
      </div>
    </div>
  );
};
